import { FormattedCellKey } from "@/pages/EditSubjectPlan/types/types";

type FormattedCellKeyProps = {
  row: string;
  column: string;
};

/**
 * Keeps the cell key in a consistent format across the application
 */
export const getFormattedCellKey = ({
  column,
  row,
}: FormattedCellKeyProps): FormattedCellKey => {
  return `${row}__${column}`;
};
